import AddProduct from "./add Product/addproduct";
import PurchaseList from "./PurchaseList/PurchaseList";

export{AddProduct,PurchaseList}